import { render, staticRenderFns } from "./EditOriginStoryDialog.vue?vue&type=template&id=075ff810&lang=pug&"
import script from "./EditOriginStoryDialog.vue?vue&type=script&lang=ts&"
export * from "./EditOriginStoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports